import CircleIcon from "@mui/icons-material/Circle";
import { Chip, chipClasses } from "@mui/material";
import { labToCss } from "service/color-math";
import type { NamedColor } from "../filter/color-filter/ColorFilter";
import type { FilterChipProps } from "./FilterChips";

export const ColorFilterChip = ({
  value,
  label,
  ...props
}: FilterChipProps<NamedColor>) => {
  return (
    <Chip
      sx={{
        [`& .${chipClasses.icon}`]: {
          color: labToCss(value.value),
        },
      }}
      icon={<CircleIcon />}
      label={`${label}: ${value.name}`}
      {...props}
    />
  );
};
